import { PRICE_RANGES, PRICE_MAP } from './searchFilterConstants'

const sortFacetAccordingToCount = (facetMap: Record<string, number>) =>
  Object.keys(facetMap).sort((a, b) => facetMap[b] - facetMap[a])

const COLOR_OVERRIDE_MAP: Record<string, string> = {
  multi: `url("//images.ctfassets.net/afruo3gr1g6h/8gIR9LjwMiBlNdbO8RlV7/09658031bf8514ce60a4eb5b66e611e2/multi-color_filter.svg")`,
}

const UNSUPPORTED_DEPARTMENT = new Set(['Emerging', 'Logistics', 'Health Care'])

const getPrimaryColorValueGetter = (facetMap: Record<string, number>) =>
  sortFacetAccordingToCount(facetMap).map((colorValue: string) => ({
    hex: colorValue,
    name: colorValue,
    imgUrl: COLOR_OVERRIDE_MAP[colorValue],
  }))

const getPriceValueGetter = (facetMap: Record<string, number>) => {
  const allPricePoints = Object.keys(facetMap)
  return PRICE_RANGES.filter(price => {
    const { minPrice, maxPrice } = PRICE_MAP[price] || {}
    return !!allPricePoints.some(pricePoint => {
      const numericPrice = Number(pricePoint)
      return numericPrice >= minPrice && !(maxPrice && numericPrice > maxPrice)
    })
  })
}

const getBusinessDepartmentValueGetter = (facetMap: Record<string, number>) => {
  return sortFacetAccordingToCount(facetMap).filter(department => !UNSUPPORTED_DEPARTMENT.has(department))
}

export const FACET_TO_OPTION_VALUE_GETTER: Record<string, (arg: any) => string[] | { hex?: string; name: string }[]> = {
  DEFAULT: sortFacetAccordingToCount,
  primary_colors: getPrimaryColorValueGetter,
  prices: getPriceValueGetter,
  business_department: getBusinessDepartmentValueGetter,
}
